import { Button, CopyButton, Menu, Modal } from '@mantine/core';
import { IconQrcode } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import logo from 'src/assets/logo.svg';
import usePrintQRCode from 'src/Hooks/Printables/usePrintQRCode';
import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';

import styles from './QRCodeModal.module.scss';
import { Props } from './QRCodeModal.types';

const QRCodeModal = ({ open, url, onClose, exportName }: Props) => {
  const { t, i18n } = useTranslation();
  const { data: asset } = useFetchAssetDetails();

  const { printQRCode } = usePrintQRCode();

  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={<div className={styles.title}>{exportName}</div>}
      withCloseButton={true}
    >
      <div className={styles.container}>
        <QRCodeSVG
          value={url}
          size={400}
          imageSettings={{ src: logo, height: 80, width: 80, excavate: true }}
          level="H"
          fgColor={'#114B50'}
          style={{ width: '100%', height: 'auto' }}
        />
        <div className={styles.actions}>
          <CopyButton value={url}>
            {({ copied, copy }) => (
              <Button color={copied ? 'teal' : undefined} onClick={copy} variant={'outline'}>
                {copied
                  ? t('qrcodemodal.linkCopied', 'Lien copié')
                  : t('qrcodemodal.copyLink', 'Copier le lien')}
              </Button>
            )}
          </CopyButton>
          <Menu shadow="md" width={250} withArrow>
            <Menu.Target>
              <Button>{t('qrcodemodal.print', 'Imprimer')}</Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                leftSection={<IconQrcode height={16} />}
                onClick={() =>
                  printQRCode({
                    cmSize: 3,
                    topText: exportName,
                    bottomText: `${asset?.name} - ${dayjs().format('LLLL')}`,
                    value: url,
                  })
                }
              >
                {t('qrcodemodal.small', 'Petit QR code (3cm)')}
              </Menu.Item>
              <Menu.Item
                leftSection={<IconQrcode height={16} />}
                onClick={() =>
                  printQRCode({
                    cmSize: 5,
                    topText: exportName,
                    bottomText: `${asset?.name} - ${dayjs().format('LLLL')}`,
                    value: url,
                  })
                }
              >
                {t('qrcodemodal.midSize', 'Moyen QR code (5cm)')}
              </Menu.Item>
              <Menu.Item
                leftSection={<IconQrcode height={16} />}
                onClick={() =>
                  printQRCode({
                    cmSize: 7,
                    topText: exportName,
                    bottomText: `${asset?.name} - ${dayjs().format('LLLL')}`,
                    value: url,
                  })
                }
              >
                {t('qrcodemodal.big', 'Grand QR code (7cm)')}
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>
    </Modal>
  );
};

export default QRCodeModal;
